export enum PhotoFlags {
  ActuarProfile = 1,
  AppProfile = 2,
  Facial = 4,
}
